import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'url-wyswyg',
  templateUrl: './url-wyswyg.component.html',
  styleUrls: ['./url-wyswyg.component.css']
})
export class UrlWyswygComponent extends ElementComponent {
  @Input() override data: any = {
    text: '',
    href: 'http://'
  }

  checkUrl() {
    if (!this.data.href.startsWith('http://')&&!(this.data.href as string).startsWith('https://')) {
      this.data.href = 'http://' + this.data.href;
    }
    if (this.data.text === "" || this.data.href.startsWith(this.data.text)) {
      this.data.text = this.data.href;
    }
  }
}
